
import {  Stack,  } from "@mui/material";
import { Navigate, Outlet } from "react-router-dom";
import React from "react";
import SideBar from "./Sidebar";


const isAuthenticated = true;

const DashboardLayout = () => {

  if(!isAuthenticated){
    return <Navigate to="/auth/login"/>;
  }


  return (
    <Stack direction="row">
   {/* Sidebar*/}
      <SideBar />
      <Outlet />
    </Stack>
  );
};

export default DashboardLayout;
